export default __webpack_public_path__ + "static/media/BankOfAmerica.b3081382.svg";